import clsx from 'clsx'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import type { InputDateRangeProps } from './type'

import { InputDate } from '@/components/ui'

export const InputDateRange = ({
  value,
  height,
  isError,
  placeholder,
  disabled = false,
  disableClearFrom = false,
  disableClearTo = false,
  handleChange,
  handleFocus,
  handleBlur,
}: InputDateRangeProps) => {
  const { t } = useTranslation()
  const onChange = React.useCallback(
    (key: keyof typeof value, input: string | Date | undefined) => {
      handleChange({
        ...value,
        [key]: input,
      })
      if (key === 'from') {
        setIsFromActive(false)
      } else {
        setIsToActive(false)
      }
    },
    [value, handleChange]
  )

  const [isFromActive, setIsFromActive] = useState<boolean>(false)
  const [isToActive, setIsToActive] = useState<boolean>(false)

  useEffect(() => {
    if (isFromActive || isToActive) {
      handleFocus && handleFocus()
    } else if (!isFromActive && !isToActive) {
      handleBlur && handleBlur()
    }
  }, [isFromActive, isToActive, handleFocus, handleBlur])

  return (
    <div className={clsx('tw-flex tw-items-center')}>
      <InputDate
        value={value.from}
        height={height}
        isError={isError}
        placeholder={placeholder?.from ?? t('common.placeholder.fromDate')}
        disabled={disabled}
        popperPlacement={'bottom-start'}
        closeOnScroll={false}
        isClearable={!disableClearFrom}
        onChange={(input) => onChange('from', input)}
        onFocus={() => {
          setIsFromActive(true)
        }}
        onBlur={() => {
          setIsFromActive(false)
        }}
      />

      <span className={clsx('tw-mx-4', 'tw-text-xs', 'tw-outline-none')}>
        ～
      </span>

      <InputDate
        value={value.to}
        height={height}
        isError={isError}
        placeholder={placeholder?.to ?? t('common.placeholder.toDate')}
        disabled={disabled}
        popperPlacement={'bottom-end'}
        isClearable={!disableClearTo}
        onChange={(input) => onChange('to', input)}
        closeOnScroll={false}
        onFocus={() => {
          setIsToActive(true)
        }}
        onBlur={() => {
          setIsToActive(false)
        }}
      />
    </div>
  )
}
